/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { appointmentListApi,updateStaffApi, appointmentDeleteApi, filterListApi, cancelappointmnetApi, rescheduleAppointmentApi, timeSlotApi, logOutApi, staffApi, clientComboList, comboImgPath, downloadBill, downloadComboBill, servicesCategoryListApi, serviceListApi, clientListApi, branchListApi, staffForCalendar, gstBookAppointment,staffListApi } from '../../../Context/api'
import { cancelAppointmentValidation } from '../../../Context/validation'
import { commonMessage, roleNames, statusCodes } from '../../../Constants/generalConfig'
import { toast } from 'react-toastify'
import { useContext, useEffect } from 'react'
import { useState } from 'react'
import moment from 'moment/moment'
import { useFormik } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import { Notifications } from '../../../App'
import { environment } from '../../../../src/Context/environment'
import * as Yup from 'yup'

const UseAppointmentList = () => {
  const { userInfo } = useContext(Notifications)
  const [appointmentListData, setAppointmentListData] = useState([])
  const userData = JSON.parse(localStorage.getItem('userData'))
  const status = JSON.parse(localStorage.getItem('status'))
  const [modalData, setModalData] = useState(' ')
  const timeZoneData = Intl.DateTimeFormat().resolvedOptions().timeZone
  // const [branchList, setBranchList] = useState([])
  const [teamList, setTeamList] = useState([])
  const [clientList, setClientList] = useState([])
  // const [serviceList, setServiceList] = useState([])
  const [spinner, setSpinner] = useState(false)
  const [count, setCount] = useState(1)
  const [page, setPage] = useState(1)
  const PER_PAGE = 10
  const [show, setShow] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showEmailModal, setShowEmailModal] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [selectedStaffId, setSelectedStaffId] = useState("");

  const [showUpdateStaff, setShowUpdateStaff] = useState(false)
  const [showBillGenModal, setShowBillGenModal] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [slotTime, setSlotTime] = useState([])
  const [slots, setSlots] = useState([])
  const [date, setDate] = useState('')
  const [buttonType, setButtonType] = useState('download')
  const [tab, setTab] = useState(1)
  const [clientComboData, setClientComboData] = useState([])
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [apiType, setApiType] = useState('appointment');
  const [serviceCategoryList, setServiceCategoryList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [clientData, setClientData] = useState([])
  const [branchData, setBranchData] = useState([])
  const [teamMember, setTeamMember] = useState([])
  const [emailError, setEmailError] = useState('');
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [formData, setFormData] = useState({
    email: '',
  });
    const [teamMemberList, setTeamMemberList] = useState([]);

  const [billFormValues, setBillFormValues] = useState({
    startDateTime: "",
    endDateTime: "",
    timezone: "",
    branchId: "",
    staffId: "",
    serviceId: "",
    amount: null,
    createdby_id: "",
    clientId: "",
    providerId: "",
    visitType: "",
    categoryId: "",
  });

  const navigate = useNavigate()
  const { type, statusType } = useParams()
  const [statusNames, setStatusNames] = useState([
    {
      name: 'Accepted',
      value: 'ACCEPTED',
      _id: 1
    },
    {
      name: 'Pending',
      value: 'PENDING',
      _id: 2
    },
    {
      name: 'Cancelled',
      value: 'CANCELLED',
      _id: 3
    },
  ])
  // console.log(statusNames,'statusNames')
  const [val, setVal] = useState({
    branchFil: '',
    teamFil: '',
    clientFil: '',
    serviceFil: '',
    appointmentFilter: '',
  })
  const [dateFilter, setDateFilter] = useState('TODAY')
  const [filterInput, setFilterInput] = useState({
    team: [],
    branch: [],
    client: [],
    status: [],
    service: [],
    endDate: '',
    startDate: '',
  })
  // console.log(filterInput,'filterInput')
  // console.log(dateFilter,'dateFilter');

  const [availabilityId, setAvailabilityId] = useState('')


  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
  }



  const handleBillGenerateChange = (e, data = null) => {
    const { name, value } = e.target;
    if (data === 'CATEGORYID') {
      setCategoryId(value)
      bookAppointmentFormik.setFieldValue('categoryId', value);
    } else {
      bookAppointmentFormik.setFieldValue(name, value);
    }

    // setBillFormValues((prev) => ({
    //   ...prev,
    //   [name]: value
    // }))
  }

  useEffect(() => {
    if (userData == null) {
      navigate('/')
    }
    else {
      if (tab === 1) {
         staffList()
        getAppointmentData()
        filterList()
       
      }
      if (tab === 2) {
        clientCombo()
      }
    }
  }, [page])

  useEffect(() => {
    if (showBillGenModal) {
      serviceCategoryListing();
      getClientList();
      getBranchList();
      teamMembers();
    }
    if (userData?.locationId) {
      bookAppointmentFormik.setFieldValue('branchId', userData.locationId);
    }

  }, [showBillGenModal]);

  useEffect(() => {
    if (categoryId) {
      serviceListing(categoryId);
    }
  }, [categoryId])

  const logOutFun = () => {
    axios.post(logOutApi(), { deviceId: userData.deviceId, userId: userData?.userId, type: 'WEBPROVIDER' }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        localStorage.removeItem('userData')
        navigate('/')
      }
    })
  }
  const filterList = () => {
    axios.post(filterListApi(), { userId: userData?.roleTitle === roleNames.SERVICE_PROVIDER ? userData?.providerId : userData.providerId }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        // setBranchList(resp.data.data.branchName)
        setClientList(resp.data.data.clientData)
        // setServiceList(resp.data.data.serviceName)
        setTeamList(resp.data.data.staffData)
      }
      else {
        toast.error(resp.data.message)
      }
    }).catch(() => { })
  }
  const cancelAppointment = useFormik({
    initialValues: { reason: '' },
    validationSchema: cancelAppointmentValidation,
    onSubmit: (values) => {
      const data = {
        appointmentId: modalData._id,
        timezone: timeZoneData === 'Asia/Calcutta' ? 'Asia/Kolkata' : timeZoneData,
        startDateTime: modalData.startDateTime,
        endDateTime: modalData.endDateTime,
        clientId: modalData.clientId,
        staffId: modalData.staffId,
        reason: values.reason,
        status: 'CANCELLED'
      }
      setSpinner(true)
      axios.post(cancelappointmnetApi(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message)
          getAppointmentData()
          setShowModal(false)
          cancelAppointment.resetForm()
          setSpinner(false)
        }
        else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun()
        }
        else {
          toast.error(resp.data.message)
          setSpinner(false)
        }
      }).catch(() => { toast.error(commonMessage.networkError); setSpinner(false) })
    }

  })

  const staffList = () => {
    const payload = {
      userId: userData?.providerId,
      isActive: true,
      count: 100,
      isAccepted: "accepted",
      branchId: userData?.locationId,
    };
    console.log(payload, 'payload for staff list') // Debugging log
    axios
      .post(staffListApi(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } })
      .then((resp) => (resp.data.code === statusCodes.ok ? setTeamMemberList(resp.data.data || []) : setTeamMember([])))
      .catch((err) => {
        console.error("Error fetching team members:", err);
        setTeamMemberList([]);
      });
  };
  const getAppointmentData = () => {
    let data = {
      page: page,
      count: PER_PAGE,
      isDeleted: false,
      providerId: userData?.roleTitle === roleNames.SERVICE_PROVIDER ? userData?.userId : userData.createdbyId,
      getDataOf: dateFilter.length || status?.status ? 'CUSTOM' : 'UPCOMING_APPOINTMENTS',
      branches: filterInput.branch.length ? filterInput.branch : [],
      clients: filterInput.client.length ? filterInput.client : [],
      staffs: filterInput.team.length ? filterInput.team : [],
      services: filterInput.service.length ? filterInput.service : [],
      status: filterInput.status.length ? filterInput.status : [],
      branchId: userData?.locationId
    }
    if (status?.status) {
      data.status.push(status?.status)
    }
    // Dashboard Data
    if (type === 'TODAY') {
      data.getDataOf = 'CUSTOM'
      data.startDateFilter = moment().startOf('day').utc()
      data.endDateFilter = moment().endOf('day').utc()
      data.status = statusType === 'book' ? ['ACCEPTED'] : statusType === 'pending' ? ['PENDING'] : ['CANCELLED']
      // if(!filterInput?.status?.length){
      //   setDateFilter('TODAY')
      //   const selectedStatus = statusType === 'book' ? ['ACCEPTED'] : statusType === 'pending' ? ['PENDING'] : ['CANCELLED'];
      //   data.status = selectedStatus;
      //   setFilterInput((prev) => ({ ...prev, status: selectedStatus }));
      //   setStatusNames((prev) =>
      //     prev.map((status) => ({
      //       ...status,
      //       isChecked: selectedStatus.includes(status.value),
      //     }))
      //   );
      // }

    }
    if (type === 'LAST_MONTH') {
      data.getDataOf = 'CUSTOM'
      data.startDateFilter = moment().startOf('day').subtract(30, 'days').utc()
      data.endDateFilter = moment().startOf('day').utc()
      data.status = statusType === 'book' ? ['ACCEPTED'] : statusType === 'pending' ? ['PENDING'] : ['CANCELLED']
      // setDateFilter('LAST30')
      // const selectedStatus = statusType === 'book' ? ['ACCEPTED'] : statusType === 'pending' ? ['PENDING'] : ['CANCELLED'];
      // data.status = selectedStatus;
      // setFilterInput((prev) => ({ ...prev, status: selectedStatus }));
      // setStatusNames((prev) =>
      //   prev.map((status) => ({
      //     ...status,
      //     isChecked: selectedStatus.includes(status.value),
      //   }))
      // );
    }
    if (type === 'UPCOMMING') {
      data.getDataOf = 'UPCOMING_APPOINTMENTS'
      data.status = statusType === 'book' ? ['ACCEPTED'] : statusType === 'pending' ? ['PENDING'] : ['CANCELLED']
      // const selectedStatus = statusType === 'book' ? ['ACCEPTED'] : statusType === 'pending' ? ['PENDING'] : ['CANCELLED'];
      // data.status = selectedStatus;
      // setFilterInput((prev) => ({ ...prev, status: selectedStatus }));
      // setStatusNames((prev) =>
      //   prev.map((status) => ({
      //     ...status,
      //     isChecked: selectedStatus.includes(status.value),
      //   }))
      // );

    }



    if (dateFilter === 'TODAY') {
      data.startDateFilter = moment().startOf('day').utc()
      data.endDateFilter = moment().endOf('day').utc()
    } else if (dateFilter === 'LAST7') {
      data.startDateFilter = moment().startOf('day').subtract(7, 'days').utc()
      data.endDateFilter = moment().startOf('day').utc()
    } else if (dateFilter === 'LAST30') {
      data.startDateFilter = moment().startOf('day').subtract(30, 'days').utc()
      data.endDateFilter = moment().startOf('day').utc()
    }
    if (status?.day === 'TODAY') {
      data.startDateFilter = moment().startOf('day').utc()
      data.endDateFilter = moment().endOf('day').utc()
    }
    if (status?.day === 'LAST15') {
      data.startDateFilter = moment().startOf('day').subtract(15, 'days').utc()
      data.endDateFilter = moment().startOf('day').utc()
    }
    if (status?.day === 'LAST_MONTH') {
      data.startDateFilter = moment().startOf('day').subtract(30, 'days').utc()
      data.endDateFilter = moment().startOf('day').utc()
    }
    if (dateFilter === 'CUSTOM' && filterInput.startDate === '' && filterInput.endDate === '') return toast.warn('Please select start date and end date ')
    if (dateFilter === 'CUSTOM' && filterInput.startDate === '') return toast.warn('Please select start date')
    if (dateFilter === 'CUSTOM' && filterInput.endDate === '') return toast.warn('Please select end date')
    if (filterInput.startDate > filterInput.endDate) return toast.warn('Start date can not be greater than end date ')
    else if (dateFilter === 'CUSTOM') {
      data.startDateFilter = moment(filterInput.startDate).startOf('day').utc()
      data.endDateFilter = moment(filterInput.endDate).endOf('day').utc()
    }
    setSpinner(true)
    axios.post(appointmentListApi(), data, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setAppointmentListData(resp.data)
        setSpinner(false)
        setCount(resp.data.totalCount)
        setShowFilter(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        setCount([])
        setAppointmentListData([])
        setSpinner(false)
      }
    })
      .catch(() => {
        setSpinner(false)
        toast.error(commonMessage.networkError)
      })
  }
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    event.preventDefault()
    setFilterInput((prevProps) => ({
      ...prevProps,
      [name]: value
    }));
  };
  // const setBranches = (event, branchId, i) => {
  //   let temp = branchList
  //   let filterInputs = filterInput
  //   if (event.target.checked) {
  //     filterInputs.branch.push(branchId)
  //     temp[i]['isChecked'] = true
  //   }
  //   else {
  //     filterInputs.branch = filterInputs.branch.filter((id) => id !== branchId)
  //     temp[i]['isChecked'] = false
  //   }
  //   setBranchList([...temp])
  //   setFilterInput(filterInputs)
  // }
  const setTeam = (event, teamId, i) => {
    let temp = teamList
    let filterInputs = filterInput
    if (event.target.checked) {
      filterInputs.team.push(teamId)
      temp[i]['isChecked'] = true
    }
    else {
      filterInputs.team = filterInputs.team.filter((id) => id !== teamId)
      temp[i]['isChecked'] = false
    }
    setTeamList([...temp])
    setFilterInput(filterInputs)
  }
  const setClient = (event, clientId, i) => {
    let temp = clientList
    let filterInputs = filterInput
    if (event.target.checked) {
      filterInputs.client.push(clientId)
      temp[i]['isChecked'] = true
    }
    else {
      filterInputs.client = filterInputs.client.filter((id) => id !== clientId)
      temp[i]['isChecked'] = false
    }
    setClientList([...temp])
    setFilterInput(filterInputs)

  }
  // const setService = (event, serviceId, i) => {
  //   let temp = serviceList
  //   let filterInputs = filterInput
  //   if (event.target.checked) {
  //     filterInputs.service.push(serviceId)
  //     temp[i]['isChecked'] = true
  //   }
  //   else {
  //     filterInputs.service = filterInputs.service.filter((id) => id !== serviceId)
  //     temp[i]['isChecked'] = false
  //   }
  //   setServiceList([...temp])
  //   setFilterInput(filterInputs)
  // }
  const setStatus = (event, statusId, i) => {
    let temp = statusNames
    let filterInputs = filterInput
    if (event.target.checked) {
      filterInputs.status.push(statusId)
      temp[i]['isChecked'] = true
    }
    else {
      filterInputs.status = filterInputs.status.filter((id) => id !== statusId)
      temp[i]['isChecked'] = false
    }
    setStatusNames([...temp])
    setFilterInput(filterInputs)
  }
  const clearAllFilter = () => {
    setFilterInput({ team: [], branch: [], client: [], status: [], service: [], endDate: '', startDate: '', })
    setDateFilter('')


    // let branch = branchList
    // branch.map((branch) => (branch['isChecked'] = false))
    // setBranchList([...branch])

    let team = teamList
    team.map((team) => team.isChecked && (team.isChecked = false))
    setTeamList(team)

    let client = clientList
    client.map((client) => client.isChecked && (client.isChecked = false))
    setClientList(client)

    // let service = serviceList
    // service.map((service) => service.isChecked && (service.isChecked = false))
    // setServiceList(service)

    let status = statusNames
    status.map((item) => item.isChecked && (item.isChecked = false))
    setStatusNames(status)
  }
  const timesSlot = (day) => {
    setDate(moment(day).format('YYYY-MM-DD'))
    const data = {
      timezone: timeZoneData,
      branchId: modalData.branchId,
      serviceId: modalData.serviceId,
      staffId: modalData.staffId,
      day: moment(day).format('dddd'),
      selectedDate: moment(day).format('YYYY-MM-DD'),
      availabilityId: availabilityId,
      providerId: userData?.userId
    }
    axios.post(timeSlotApi(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setSlots(resp.data.data)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        toast.error(resp.data.message)
      }
    }).catch(() => { })
  }
  const appointmentReschedule = () => {
    const data = {
      appointmentId: modalData._id,
      startDateTime: moment(date + '' + moment(slotTime.startTime).format('HH:mm'), 'YYYY-MM-DD HH:mm').format(),
      endDateTime: moment(date + '' + moment(slotTime.endTime).format('HH:mm'), 'YYYY-MM-DD HH:mm').format(),
      timezone: timeZoneData === 'Asia/Calcutta' ? 'Asia/Kolkata' : timeZoneData
    }
    setSpinner(true)
    axios.post(rescheduleAppointmentApi(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message)
        getAppointmentData()
        setShow(false)
        // appointmentReschedule.resetForm()
        setSpinner(false)
        setSlotTime([])
        setSlots([])
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        toast.error(resp.data.message)
        setSpinner(false)
      }
    }).catch(() => {
      toast.error(commonMessage.networkError)
      setSpinner(false)
    })
  }
  const handleChange = (e) => {
    setVal({ ...val, [e.target.name]: e.target.value })
  }
  const appointmentDelete = () => {
    setSpinner(true)
    axios.post(appointmentDeleteApi(), { id: modalData._id, timezone: timeZoneData === 'Asia/Calcutta' ? 'Asia/Kolkata' : timeZoneData }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message)
        getAppointmentData()
        setShowDelete(false)
        setSpinner(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        toast.error(resp.data.message)
        setSpinner(false)
      }
    }).catch(() => {
      setSpinner(false)
      toast.error(commonMessage.networkError)
    })
  }

  const updateStaff = () => {


    setSpinner(true)
    axios.post(updateStaffApi(), { id: modalData._id,staffId:selectedStaffId,createdby_id:userData?.providerId, timezone: timeZoneData === 'Asia/Calcutta' ? 'Asia/Kolkata' : timeZoneData }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message)
        getAppointmentData()
        setShowDelete(false)
        setSpinner(false)
        setSelectedStaffId("")
        setShowModal(false)
        setShowUpdateStaff(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        toast.error(resp.data.message)
        setSpinner(false)
      }
    }).catch(() => {
      setSpinner(false)
      toast.error(commonMessage.networkError)
    })
  }

  const getStaffList = (item) => {
    const data = {
      branchId: item.branchId,
      serviceId: item.serviceId,
      providerId: userData?.roleTitle === roleNames.SERVICE_PROVIDER ? userData?.userId : userData.createdbyId
    }
    axios.post(staffApi(), data, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        let availabilityId = resp.data.data.find((data) => data.staffId === item?.staffId?.[0])
        setAvailabilityId(availabilityId?.availabilityId)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else if (resp.data.code === 404 && resp.data.message === 'No record found') {
        toast.warn("Team is not available of this branch")
      }

      else {
        setAvailabilityId('')
        toast.error(resp.data.message)
      }
    }).catch(() => { })
  }

  const clientCombo = () => {
    setSpinner(true)
    axios.post(clientComboList(), { page: page, count: PER_PAGE }, { headers: { Authorization: `Bearer ${userData.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setClientComboData(resp.data.data)
        setCount(resp.data.totalCount)
        setSpinner(false)
      }
      else {
        setClientComboData([])
        setSpinner(false)
      }
    })
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


  const downloadBillAPI = (id) => {
    const data = {
      appointmentId: id
    }
    if (buttonType === 'sendEmail' && formData.email) {
      data.email = formData.email
      data.isSendMail = true
    }
    axios.post(downloadBill(), data, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        if (buttonType === 'sendEmail') toast.success('Bill send to your email successfully')
        else {

          toast.success('Download successfully')
          // window.open(resp?.data?.data?.pdfPath)
          window.open(`${environment.baseUrl}${resp?.data?.data?.pdfPath}`, '_blank');
          // window.open(resp?.data?.data?.pdfPath)
        }
        getAppointmentData();
        setShowEmailModal(false);
        setFormData('')
        setButtonType('download');

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else if (resp.data.code === 404 && resp.data.message === 'No record found') {
        toast.warn("Item is not downloaded")
      }
      else {
        // setAvailabilityId('')
        toast.error(resp.data.message)
      }
    }).catch(() => { })
  }


  const downloadComboBillAPI = (id) => {
    const data = {
      purchaseId: id
    }

    if (buttonType === 'sendEmail' && formData.email) {
      data.email = formData.email
      data.isSendMail = true
    }
    axios.post(downloadComboBill(), data, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        if (buttonType === 'sendEmail') toast.success('Bill send to your email successfully')
        else {
          toast.success('Download successfully')
          // window.open(resp?.data?.data?.pdfPath)
          window.open(`${environment.baseUrl}${resp?.data?.data?.pdfPath}`, '_blank');
          // window.open(resp?.data?.data?.pdfPath)
        }
        setShowEmailModal(false);
        setFormData('')
        setButtonType('download');

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else if (resp.data.code === 404 && resp.data.message === 'No record found') {
        toast.warn("Item is not downloaded")
      }
      else {
        // setAvailabilityId('')
        toast.error(resp.data.message)
      }
    }).catch(() => { })
  }


  // const handleEmailSubmit = () => {
  //   if (apiType === 'appointment') {
  //     downloadBillAPI(selectedAppointmentId);

  //   } else if (apiType === 'combo') {
  //     downloadComboBillAPI(selectedAppointmentId);

  //   }
  // };


  const handleEmailSubmit = () => {
    if (!validateEmail(formData.email)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    setEmailError(''); // clear error if email is valid

    if (apiType === 'appointment') {
      downloadBillAPI(selectedAppointmentId);
    } else if (apiType === 'combo') {
      downloadComboBillAPI(selectedAppointmentId);
    }
  };





  // Add validation schema (add this near the other validation schemas)
  const bookAppointmentValidation = Yup.object().shape({
    clientId: Yup.string().required('Client is required'),
    branchId: Yup.string().required('Branch is required'),
    startDateTime: Yup.string().required('Start date & time is required'),
    endDateTime: Yup.string().required('End date & time is required'),
    staffId: Yup.string().required('Team is required'),
    serviceId: Yup.string().required('Service is required'),
    categoryId: Yup.string().required('Service category is required'),
    amount: Yup.number()
      .required('Amount is required')
      .positive('Amount must be positive')
      .typeError('Amount must be a number'),
    visitType: Yup.string().required('Visit type is required'),
  });

  // Add formik for booking appointment (add this near the other formik declarations)
  const bookAppointmentFormik = useFormik({
    initialValues: {
      startDateTime: "",
      endDateTime: "",
      branchId: userData?.locationId || "",
      staffId: "",
      serviceId: "",
      amount: "",
      clientId: "",
      visitType: "",
      categoryId: "",
      isSendMail: false,
      email: ''
    },
    
    validationSchema: bookAppointmentValidation,
    onSubmit: (values, { setSubmitting }) => {
      const { isSendMail, email } = values;
      if (isSendMail && (!email || email.trim() === '')) {
        toast.error("Please fill the email.");
        setSubmitting(false); // stop the form from being in submitting state
        return;
      }

      const payload = {
        // startDateTime: values.startDateTime,
        // endDateTime: values.endDateTime,
        startDateTime: new Date(values.startDateTime).toISOString(),
        endDateTime: new Date(values.endDateTime).toISOString(),
        timezone: timeZone,
        branchId: values.branchId,
        staffId: values.staffId,
        serviceId: values.serviceId,
        amount: values.amount,
        createdby_id: userData?.providerId,
        clientId: values.clientId,
        providerId: userData?.providerId,
        visitType: values.visitType,
        isSendMail: values.isSendMail,
        email: values.email || null
      }



      axios.post(gstBookAppointment(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` }
      }).then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message)
            getAppointmentData()
          // if (resp.data.message) window.open(`${environment.baseUrl}${resp?.data?.data?.imagePath}`, '_blank');
          // else toast.success("No data available for download")
       if (!values.isSendMail) {
      if (resp?.data?.data?.imagePath) {
        window.open(`${environment.baseUrl}${resp.data.data.imagePath}`, '_blank');
      }
    }
          // getAppointmentData()
          setSpinner(false)
          bookAppointmentFormik.resetForm();
          setShowBillGenModal(false);
        }
        else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun()
        }
      }).catch((error) => {
        toast.error(error.response?.data?.message || commonMessage.networkError)
      }).finally(() => {
        setSubmitting(false); // always reset submitting state
      });
    }
  });




  const handleServiceChange = (e, serviceList, bookAppointmentFormik) => {
    const selectedServiceId = e.target.value;
    const selectedService = serviceList.find(service => service._id === selectedServiceId);

    console.log(selectedService, 'selectedService')
    console.log(!selectedService, 'noteselectedService')
    console.log(selectedService.duration, 'selectedService.duration')

    bookAppointmentFormik.setFieldValue("serviceId", selectedServiceId);

    if (!selectedService) return;

    bookAppointmentFormik.setFieldValue("amount", selectedService.fixedAmount || "");
    bookAppointmentFormik.setFieldValue("categoryId", selectedService.categoryId || "");

  };

  function formatDateLocal(date) {
    const pad = (n) => n.toString().padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Month is 0-indexed
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }


  useEffect(() => {
    const selectedService = serviceList.find(service => service._id === bookAppointmentFormik.values.serviceId);
    const startDateTime = bookAppointmentFormik.values.startDateTime;

    if (selectedService && startDateTime) {
      const start = new Date(startDateTime);
      const totalDuration = (selectedService.duration || 0) + 20; // in minutes
      const end = new Date(start.getTime() + totalDuration * 60000); // add minutes

      const formattedEnd = formatDateLocal(end); // ✅ Use local format
      if (end > start) {
        bookAppointmentFormik.setFieldValue("endDateTime", formattedEnd);
      }
    }
  }, [bookAppointmentFormik.values.startDateTime, bookAppointmentFormik.values.serviceId]);

  const serviceCategoryListing = () => {
    const payload = {
      count: 1000,
      page: 1,
      userId: userData?.providerId,
      branchId: userData?.locationId,
      isActive: true,
    }
    axios.post(servicesCategoryListApi(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        // toast.success(resp.data.message)
        setServiceCategoryList(resp.data.data)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else if (resp.data.code === 404 && resp.data.message === 'No record found') {
        toast.warn("Item is not downloaded")
      }
      else {
        // setAvailabilityId('')
        toast.error(resp.data.message)
      }
    }).catch(() => { })
  }


  const serviceListing = (id) => {
    const data = {
      categoryId: id,
      page: 1,
      count: 1000,
      isActive: true
    }
    setSpinner(true)
    axios.post(serviceListApi(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setServiceList(resp.data.data)
        setCount(resp.data.totalCount)
        setSpinner(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        setPage(1)
        setServiceList([])
        setSpinner(false)
      }
    })
      .catch(() => {
        toast.error(commonMessage.networkError)
        setSpinner(false)
      })
  }

  const getClientList = () => {
    const data = {
      providerId: userData?.providerId,
      isActive: true,
      // isAccepted: 'accepted',
      count: 1000,
      page: 1,
    }
    axios.post(clientListApi(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setClientData(resp.data.data)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
    }).catch(() => { })
  }

  const getBranchList = () => {
    axios.post(branchListApi(), { userId: userData?.userId, isActive: true, isDeleted: false, page: 1, count: 100 }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        const branches = resp.data.data;
        setBranchData(branches);

        const defaultBranch = branches.find(branch => branch._id === userData?.locationId);
        if (defaultBranch) {
          bookAppointmentFormik.setFieldValue('branchId', defaultBranch._id);
        }

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
    }).catch(() => { })
  }

  const teamMembers = () => {

    const data = {
      providerId: userData?.providerId,
      branchId: userData?.locationId,
      count: 1000
    }
    axios.post(staffForCalendar(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setTeamMember(resp.data.data)
        // setCurrentTeam(resp.data.data[0]._id)
      }
      else {
        setTeamMember([])
      }
    })
  }





  return {
    appointmentDelete,
    updateStaff,
    handleChange,
    appointmentReschedule,
    timesSlot,
    clearAllFilter,
    setStatus,
    setClient,
    setTeam,
    handleInputChange,
    getAppointmentData,
    setAppointmentListData,
    setModalData,
    setTeamList,
    setClientList,
    setSpinner,
    setCount,
    setPage,
    setShow,
    setShowModal,
    filterList,
    logOutFun,
    setShowFilter,
    setSlotTime,
    setSlots,
    setDate,
    navigate,
    setStatusNames,
    setVal,
    setDateFilter,
    setFilterInput,
    getStaffList,
    setShowDelete,
    setTab,
    clientCombo,
    downloadBillAPI,
    setShowEmailModal,
    handleEmailChange,
    setButtonType,
    downloadComboBillAPI,
    setSelectedAppointmentId,
    setApiType,
    handleEmailSubmit,
    setFormData,
    setShowBillGenModal,
    handleBillGenerateChange,
    // bookAppointment,
    handleServiceChange,
    bookAppointmentFormik,
    getBranchList,
    setCategoryId,
    setEmailError,
    emailError,
    teamMember,
    branchData,
    clientData,
    serviceCategoryList,
    billFormValues,
    showBillGenModal,
    tab,
    comboImgPath,
    clientComboData,
    showDelete,
    setShowUpdateStaff,
    showUpdateStaff,
    cancelAppointment,
    appointmentListData,
    userData,
    status,
    modalData,
    timeZoneData,
    teamList,
    clientList,
    spinner,
    count,
    page,
    PER_PAGE,
    show,
    showModal,
    showFilter,
    slotTime,
    slots,
    date,
    statusNames,
    val,
    dateFilter,
    filterInput,
    userInfo,
    showEmailModal,
    buttonType,
    formData,
    selectedAppointmentId,
    apiType,
    serviceList,
    teamMemberList,
    selectedStaffId,
    setSelectedStaffId
  }
}

export default UseAppointmentList